/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBadge = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="M7 11h2v2H7zm4 0h2v2h-2z" />
      <path d="M19 6H5C3.3 6 2 7.3 2 9v6c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3V9c0-1.7-1.3-3-3-3zm1 9c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1h14c.6 0 1 .4 1 1z" />
      <path d="M15 11h2v2h-2z" />
    </g>
  </Icon>
);
export { SvgBadge as Badge };
